import { GAME_KEYS } from "../game/game.constants"
// Partner Slides Assets
import doubleLift from "@/assets/images/home/banner/doublelift.jpg"
import mongraal from "@/assets/images/home/banner/mongraal.jpg"
import clix from "@/assets/images/home/banner/homepage-header-Clix.png"
import toast from "@/assets/images/home/banner/toast.jpg"
import s1mple from "@/assets/images/home/banner/s1mple.jpg"
import mkleo from "@/assets/images/home/banner/mkleo.jpg"
import day9 from "@/assets/images/home/banner/day9.jpg"
import tftHomeSlides from "@/assets/images/home/banner/teamfight_tactics.jpg"
import averageJonas from "@/assets/images/home/banner/averagejonas.png"
import psalm from "@/assets/images/home/banner/psalm.jpg"
import snip3down from "@/assets/images/home/banner/snip3down.jpg"
import tenz from "@/assets/images/home/banner/tenz.png"
import scream from "@/assets/images/home/banner/scream.jpg"
import fallen from "@/assets/images/home/banner/homepage-header-FalleN.jpg"
import corejj from "@/assets/images/home/banner/homepage-header-CoreJJ.jpg"
import scump from "@/assets/images/home/banner/scump.jpg"
import xmithie from "@/assets/images/home/banner/xmithie.jpg"
import fruity from "@/assets/images/home/banner/homepage-header-fruity_v3.jpg"
import aphromoo from "@/assets/images/home/banner/homepage-header-aphromoo_v3.jpg"
import garrettg from "@/assets/images/home/banner/homepage-header-GarretG.jpg"
import yay from "@/assets/images/home/banner/yay.jpeg"

export const HOME_SLIDES = [
  {
    name: "Doublelift",
    image: doubleLift,
    gameKey: GAME_KEYS.LEAGUE_OF_LEGENDS,
    achievement: "7X LCS Champion",
    descriptionHtml:
      "Learn how to master League of Legends from the most accomplished pro in North America.",
  },
  {
    name: "Yay",
    image: yay,
    gameKey: GAME_KEYS.VALORANT,
    achievement: "Valorant Pro & 2022 Esports Athlete Of The Year",
    descriptionHtml:
      "Learn Optimal Valorant Training From \"El Diablo\"",
  },
  {
    name: "TenZ",
    image: tenz,
    gameKey: GAME_KEYS.VALORANT,
    achievement: "Valorant Pro and Streamer",
    descriptionHtml:
      "Learn high-level competitive concepts from one of the greatest Valorant pros in the world.",
  },
  {
    name: "ScreaM",
    image: scream,
    gameKey: GAME_KEYS.VALORANT,
    achievement: "Valorant Pro & Content Creator",
    descriptionHtml: "Learn the Duelist Class from \"The Headshot Machine.\"",
  },
  {
    name: "FalleN",
    image: fallen,
    gameKey: GAME_KEYS.CSGO,
    achievement: "CS:GO Pro",
    descriptionHtml:
      "Learn how to lead your team to victory from the greatest IGL in Counterstrike.",
  },
  {
    name: "CoreJJ",
    image: corejj,
    gameKey: GAME_KEYS.LEAGUE_OF_LEGENDS,
    achievement: "World Champion",
    descriptionHtml:
      "Learn how to carry your games from the rank 1 support in NA.",
  },
  {
    image: garrettg,
    name: "GarrettG",
    gameKey: GAME_KEYS.ROCKET_LEAGUE,
    achievement: "Rocket League World Champion",
    descriptionHtml:
      "Learn how to aerial, dribble, and shoot from the best in the world.",
  },
  {
    image: fruity,
    name: "fruity",
    gameKey: GAME_KEYS.ROCKET_LEAGUE,
    achievement: "Dreamhack and EU RLCS Champion",
    descriptionHtml: "Hone your fundamentals with a Rocket League Champion.",
  },
  {
    name: "Xmithie",
    image: xmithie,
    gameKey: GAME_KEYS.LEAGUE_OF_LEGENDS,
    achievement: "6-time LCS Champion Jungler",
    descriptionHtml:
      "Learn jungling from one of the most experienced pros in North America.",
  },
  {
    name: "Aphromoo",
    image: aphromoo,
    gameKey: GAME_KEYS.LEAGUE_OF_LEGENDS,
    achievement: "2-time LCS Champion & Support MVP",
    descriptionHtml: "Learn map control from a 2-time LCS Champion.",
  },
  {
    name: "Clix",
    image: clix,
    gameKey: GAME_KEYS.FORTNITE,
    achievement: "5X WORLD CUP QUALIFIER: SOLOS & DUOS",
    descriptionHtml:
      "Learn mechanics, mindset and consistency from one of Fortnite's most mechanically gifted players.",
  },
  {
    name: "Mongraal",
    image: mongraal,
    gameKey: GAME_KEYS.FORTNITE,
    achievement: "World Cup 2019: Solos & Duos",
    descriptionHtml:
      "Learn from the youngest and most aggressive Fortnite pro in the world.",
  },
  {
    name: "Snip3down",
    image: snip3down,
    gameKey: GAME_KEYS.APEX_LEGENDS,
    achievement: "Halo World Champion & Apex Legends Pro",
    descriptionHtml:
      "Develop the fundamental skills you'll need to rank up in Apex Legends.",
  },
  {
    name: "AverageJonas",
    image: averageJonas,
    gameKey: GAME_KEYS.VALORANT,
    achievement: "Content Creator & Pro Coach",
    descriptionHtml:
      "Learn Agent Mastery from the best Sova player in the world.",
  },
  {
    name: "Psalm",
    image: psalm,
    gameKey: GAME_KEYS.VALORANT,
    achievement: "Valorant Pro & World Cup 2019",
    descriptionHtml:
      "Sharpen your fundamentals with one of the greatest strategic and analytical minds in Valorant.",
  },
  {
    name: "S1mple",
    image: s1mple,
    gameKey: GAME_KEYS.CSGO,
    achievement: "Na'Vi AWPer, Best in the World",
    descriptionHtml:
      "Learn how to master the art of CS:GO from one of the most dominant players in the world.",
  },
  {
    name: "MKLeo",
    image: mkleo,
    gameKey: GAME_KEYS.SSBU,
    achievement: "#1 PGR Ranked Player",
    descriptionHtml:
      "Learn how to dominate Smash Ultimate like the best player in the world.",
  },
  {
    name: "ProGuides",
    image: tftHomeSlides,
    gameKey: GAME_KEYS.TEAMFIGHT_TACTICS,
    achievement: "PRO ANALYSTS",
    descriptionHtml: "Master Teamfight Tactics from the very best in the game.",
  },
  {
    name: "ScumP",
    image: scump,
    gameKey: GAME_KEYS.COD_COLD_WAR,
    achievement: "COD World Champion and Content Creator",
    descriptionHtml:
      "Learn fundamentals from the face of Professional Call of Duty.",
  },
]

export const HOME_PAGE_GAME_ORDER = [
  GAME_KEYS.LEAGUE_OF_LEGENDS,
  GAME_KEYS.FORTNITE,
  GAME_KEYS.VALORANT,
  GAME_KEYS.APEX_LEGENDS,
  GAME_KEYS.COD_COLD_WAR,
  GAME_KEYS.ROCKET_LEAGUE,
  GAME_KEYS.CSGO,
  GAME_KEYS.SSBU,
  GAME_KEYS.TEAMFIGHT_TACTICS,
]



// WEBPACK FOOTER //
// ./src/store/home/home.constants.js